import { render, staticRenderFns } from "./registrationByDate.vue?vue&type=template&id=8bf77a90&scoped=true"
import script from "./registrationByDate.vue?vue&type=script&lang=js"
export * from "./registrationByDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf77a90",
  null
  
)

export default component.exports